import { Action } from '@ngrx/store';

const prefixDefault = '[DEFAULT] ';

export class BaseAction implements Action {
  private static get prefixFinal(): string {
    if (this.prefix) {
      return this.prefix;
    }
    return prefixDefault;
  }
  protected static readonly prefix?: string;
  public static get type() {
    return `${this.prefixFinal}${this.name}`;
  }
  public readonly type!: string;

  constructor() {
    this.type = (this.constructor as any as BaseAction).type;
  }
}
